export default __webpack_public_path__ + "media/projects/yellow3-2285f10e.svg";